import * as React from 'react';

import { getKeyValuePairs } from '../CountryCodesMap';
import CommonSelect, { CommonSelectWrapperProps } from './CommonSelect';

const CountrySelect = ({
  multiple,
  placeholder = `Please select countr${multiple ? 'ies' : 'y'}`,
  ...props
}: CommonSelectWrapperProps) => {
  return (
    <CommonSelect
      {...{ placeholder, multiple, ...props }}
      values={getKeyValuePairs()}
      idKey="key"
      valueFn={(item) => item.value}
    />
  );
};
export default CountrySelect;
